//VariantBox
import React, { Component } from "react";

import Modal from "../Modal";
import classNames from "classnames";
import axios from "axios";
import config from "../../config";

import { ReactComponent as InfoIcon } from "../../assets/img/info-icon.svg";

import "./index.scss";
import Loader from "../Loader";

class VariantBox extends Component {
  state = {
    infoModal: false,
    infoLoading: false,
    infoContent: "",
    lastInfoShortcode: "",
  };

  handleOpenInfoModal = (e) => {
    e.stopPropagation();

    const { info: shortcode } = this.props;
    const { lastInfoShortcode } = this.state;

    if (!shortcode) {
      return;
    }

    if (shortcode === lastInfoShortcode) {
      this.setState({
        infoModal: true,
      });
      return;
    }

    this.setState({
      infoContent: "",
      infoLoading: true,
      infoModal: true,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.infoLoadingCancel = source.cancel;

    axios
      .get(`${config.apiBase}/shortcode/`, {
        cancelToken: source.token,
        params: {
          shortcode,
        },
      })
      .then(
        (response) => {
          this.setState({
            infoLoading: false,
            infoContent: response.data,
            lastInfoShortcode: shortcode,
          });
        },
        () => {
          this.setState({
            infoLoading: false,
          });
        }
      );
  };

  handleCloseInfoModal = (e) => {
    e.stopPropagation();

    this.setState({
      infoModal: false,
    });

    if (this.infoLoadingCancel) {
      this.infoLoadingCancel();
    }
  };

  render() {
    const { image, title, price, isActive, info, badge } = this.props;
    const { infoModal, infoContent, infoLoading } = this.state;

    const componentClass = classNames("variant-box", {
      "variant-box--active": isActive,
    });

    return (
      <div className={componentClass}>
        {info && (
          <div onClick={this.handleOpenInfoModal}>
            <InfoIcon className="variant-box__info-icon" />
            <Modal
              isOpen={infoModal}
              onRequestClose={this.handleCloseInfoModal}
            >
              {infoLoading ? (
                <Loader />
              ) : (
                <div dangerouslySetInnerHTML={{ __html: infoContent }} />
              )}
            </Modal>
          </div>
        )}

        {badge && <div className="variant-box__badge">{badge}</div>}

        {image && (
          <img src={image} className="variant-box__image" alt="Variant image" />
        )}
        <div className="variant-box__info">
          <div className="variant-box__title">{title}</div>
          <div className="variant-box__price">{price}</div>
        </div>
      </div>
    );
  }
}

export default VariantBox;
